import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import Layout from './components/Layout';
import { ApiProvider } from './Context/ApiContext';
import './custom.css'
import { CookiesProvider } from 'react-cookie';
import {ThemeProvider} from './Context/ThemeContext';

function AppContent() {
  const location = useLocation();
  
  // Rotas públicas que não devem ter o Layout (menu, notificações, etc)
  const publicRoutes = ['/ticket/create'];
  const isPublicRoute = publicRoutes.includes(location.pathname);

  return (
    <ThemeProvider>
      {isPublicRoute ? (
        // Rotas públicas sem Layout
        <Routes>
          {AppRoutes.map((route, index) => {
            const { element, ...rest } = route;
            return <Route key={index} {...rest} element={element} />;
          })}
        </Routes>
      ) : (
        // Rotas normais com Layout
        <Layout>
          <Routes>
            {AppRoutes.map((route, index) => {
              const { element, ...rest } = route;
              return <Route key={index} {...rest} element={element} />;
            })}
          </Routes>
        </Layout>
      )}
    </ThemeProvider>
  );
}

export default function App() {
  // Configurações de cookie para persistência de sessão
  const cookieOptions = {
    path: '/',
    maxAge: 60 * 60 * 24 * 30, // 30 dias em segundos
    sameSite: 'lax',
    secure: false, // Mude para true em produção com HTTPS
    httpOnly: false // Deve ser false para permitir acesso via JavaScript
  };

  return (
    <ApiProvider>
      <CookiesProvider defaultSetOptions={cookieOptions}>
        <AppContent />
      </CookiesProvider>
    </ApiProvider>
  );
}
